
import React from 'react';

const SkipToContent = () => {
  return (
    <a 
      href="#main-content" 
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:p-4 focus:bg-white focus:text-black focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-fraudeye-accent"
    >
      Skip to content
    </a>
  );
};

export default SkipToContent;
